import { BlogPost } from '../types/blog';

// Import content for each blog post
import { escapingDigitalMatrixContent } from './blogPostsContent/escaping-digital-matrix';
import { aiChatbotsCustomerServiceContent } from './blogPostsContent/ai-chatbots-customer-service';
import { webAutomationScalingBusinessContent } from './blogPostsContent/web-automation-scaling-business';
import { hiddenAiGovernanceToolkitContent } from './blogPostsContent/hidden-ai-governance-toolkit';
import { portfolioMistakesFixWithAiContent } from './blogPostsContent/portfolio-mistakes-fix-with-ai';
import { dailyContentStackTourContent } from './blogPostsContent/daily-content-stack-tour';
import { clientOnboardingAutopilotContent } from './blogPostsContent/client-onboarding-autopilot';
import { webhook101StopPollingStartPushingContent } from './blogPostsContent/webhook-101-stop-polling-start-pushing';
import { uizardWireframeIdeaToUiContent } from './blogPostsContent/uizard-wireframe-idea-to-ui';
import { framerAiLandingPageFromPromptContent } from './blogPostsContent/framer-ai-landing-page-from-prompt';
import { cursorIdeRealAiPairProgrammingContent } from './blogPostsContent/cursor-ide-real-ai-pair-programming';
import { makeVsZapierFirstAutomationContent } from './blogPostsContent/make-vs-zapier-first-automation';
import { aiContactFormDemoFlowchartContent } from './blogPostsContent/ai-contact-form-demo-flowchart';
import { aiContentStackDailyPostingContent } from './blogPostsContent/ai-content-stack-daily-posting';
import { automateClientOnboardingAiWebhooksContent } from './blogPostsContent/automate-client-onboarding-ai-webhooks';
import { buildingPortfolioSiteWithAiContent } from './blogPostsContent/building-portfolio-site-with-ai';
import { bestAiToolsWebDevsContent } from './blogPostsContent/best-ai-tools-web-devs';
import { noCodeAiStackAutomateBusinessContent } from './blogPostsContent/no-code-ai-stack-automate-business';
import { chatgptSpeedUpWebDesignContent } from './blogPostsContent/chatgpt-speed-up-web-design';
import { aiPoweredContactFormContent } from './blogPostsContent/ai-powered-contact-form';

export const blogPosts: BlogPost[] = [
  // Existing posts (positions 18-20 visually)
  {
    id: "escaping-digital-matrix",
    title: "Escaping the Digital Matrix: Why AI Automation is Your Red Pill",
    publishedAt: "2025-08-23T10:00:00Z",
    readingTime: 4,
    tags: ["AI Automation", "Digital Transformation", "Business Tools", "Efficiency", "Tech Empowerment"],
    ...escapingDigitalMatrixContent,
  },
  {
    id: "ai-chatbots-customer-service",
    title: "AI Chatbots: The 24/7 Customer Service Revolution",
    publishedAt: "2025-08-21T14:30:00Z",
    readingTime: 4,
    tags: ["AI Chatbots", "Customer Service", "Automation", "24/7 Support", "Business Efficiency"],
    ...aiChatbotsCustomerServiceContent,
  },
  {
    id: "web-automation-scaling-business",
    title: "Web Automation: Scaling Your Business Without Scaling Your Workload",
    publishedAt: "2025-08-19T09:15:00Z",
    readingTime: 4,
    tags: ["Web Automation", "Business Scaling", "Efficiency", "Automation Tools", "Growth Strategy"],
    ...webAutomationScalingBusinessContent,
  },
  // New blog posts (positions 1-17 visually)
  {
    id: "hidden-ai-governance-toolkit",
    title: "The Hidden AI Governance Toolkit for Freelancers and Solopreneurs",
    publishedAt: "2025-08-16T09:00:00Z",
    readingTime: 4,
    tags: ["AI", "Entrepreneurship", "Workflow", "Ethics"],
    ...hiddenAiGovernanceToolkitContent,
  },
  {
    id: "portfolio-mistakes-fix-with-ai",
    title: "3 Portfolio Mistakes You Can Fix with AI",
    publishedAt: "2025-08-14T09:00:00Z",
    readingTime: 4,
    tags: ["Portfolio", "AI", "Career Development"],
    ...portfolioMistakesFixWithAiContent,
  },
  {
    id: "daily-content-stack-tour",
    title: "Daily Content Stack Tour: How Top Creators Automate Their Publishing Workflow",
    publishedAt: "2025-08-11T09:00:00Z",
    readingTime: 4,
    tags: ["Content", "Workflow", "Automation", "Productivity"],
    ...dailyContentStackTourContent,
  },
  {
    id: "client-onboarding-autopilot",
    title: "Client Onboarding Auto-Pilot: From Email to Action in Seconds",
    publishedAt: "2025-08-10T09:00:00Z",
    readingTime: 4,
    tags: ["Clients", "Automation", "Workflow"],
    ...clientOnboardingAutopilotContent,
  },
  {
    id: "webhook-101-stop-polling-start-pushing",
    title: "Webhook 101: Stop Polling, Start Pushing",
    publishedAt: "2025-08-07T10:00:00Z",
    readingTime: 4,
    tags: ["AI Automation", "Digital Transformation", "Productivity", "Business Growth", "Red Pill", "Freedom"],
    ...webhook101StopPollingStartPushingContent,
  },
  {
    id: "uizard-wireframe-idea-to-ui",
    title: "Uizard to Wireframe: Idea → UI in Minutes",
    publishedAt: "2025-07-26T09:02:00Z",
    readingTime: 4,
    tags: ["Design", "Prototyping", "AI", "Web Development"],
    ...uizardWireframeIdeaToUiContent,
  },
  {
    id: "framer-ai-landing-page-from-prompt",
    title: "Framer AI in 60s: Landing Page from a Prompt",
    publishedAt: "2025-07-26T09:00:00Z",
    readingTime: 4,
    tags: ["Framer", "Design", "AI", "Web Development"],
    ...framerAiLandingPageFromPromptContent,
  },
  {
    id: "cursor-ide-real-ai-pair-programming",
    title: "Cursor IDE: Real AI Pair Programming",
    publishedAt: "2025-07-25T09:02:00Z",
    readingTime: 4,
    tags: ["Tools", "AI"],
    ...cursorIdeRealAiPairProgrammingContent,
  },
  {
    id: "make-vs-zapier-first-automation",
    title: "Make vs Zapier: Which for Your First Automation?",
    publishedAt: "2025-07-25T09:00:00Z",
    readingTime: 4,
    tags: ["No-Code", "Automation", "Business Tools"],
    ...makeVsZapierFirstAutomationContent,
  },
  {
    id: "ai-contact-form-demo-flowchart",
    title: "AI Contact Form in 30s: Demo + Flowchart",
    publishedAt: "2025-07-24T09:00:00Z",
    readingTime: 4,
    tags: ["AI", "Automation", "Web Dev"],
    ...aiContactFormDemoFlowchartContent,
  },
  {
    id: "ai-content-stack-daily-posting",
    title: "AI Content Stack (What to use to Post Daily)",
    publishedAt: "2025-07-23T09:00:00Z",
    readingTime: 4,
    tags: ["Content", "AI", "Workflow"],
    ...aiContentStackDailyPostingContent,
  },
  {
    id: "automate-client-onboarding-ai-webhooks",
    title: "Automate Client Onboarding in 30 Minutes with AI + Webhooks",
    publishedAt: "2025-07-22T09:00:00Z",
    readingTime: 4,
    tags: ["Automation", "Clients", "Webhooks"],
    ...automateClientOnboardingAiWebhooksContent,
  },
  {
    id: "building-portfolio-site-with-ai",
    title: "Building a Portfolio Site Entirely with AI",
    publishedAt: "2025-07-21T09:00:00Z",
    readingTime: 4,
    tags: ["Portfolio", "AI", "Lessons"],
    ...buildingPortfolioSiteWithAiContent,
  },
  {
    id: "best-ai-tools-web-devs",
    title: "Best AI Tools for Web Devs (That Aren't Just ChatGPT)",
    publishedAt: "2025-07-21T09:00:00Z",
    readingTime: 4,
    tags: ["AI", "Tools", "Web Development"],
    ...bestAiToolsWebDevsContent,
  },
  {
    id: "no-code-ai-stack-automate-business",
    title: "The No-Code AI Stack to Automate",
    publishedAt: "2025-07-20T09:00:00Z",
    readingTime: 4,
    tags: ["No-Code", "Automation", "Stack"],
    ...noCodeAiStackAutomateBusinessContent,
  },
  {
    id: "chatgpt-speed-up-web-design",
    title: "5 Ways to Use ChatGPT to Speed Up Web Design Projects",
    publishedAt: "2025-07-17T09:00:00Z",
    readingTime: 4,
    tags: ["AI", "Workflow", "Design"],
    ...chatgptSpeedUpWebDesignContent,
  },
  {
    id: "ai-powered-contact-form",
    title: "AI-Powered Contact Form That Replies Instantly",
    publishedAt: "2025-07-14T09:00:00Z",
    readingTime: 4,
    tags: ["AI", "Contact Forms", "Web Development", "Automation"],
    ...aiPoweredContactFormContent,
  }
];